const en = {
    monthArr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    noData: 'No data available',
    unit: {
        step: 'steps',
        steps: 'steps',
        day: 'day',
        days: 'days',
        time: 'time',
        times: 'times',
        km: 'KM',
        hour: 'hour',
        hours: 'hours',
        kcal: 'Kcal',
    },
    dailyActive: {
        title: 'DAILY ACTIVE',
        tab0: 'STEPS',
        tab1: 'CALORIES',
        tab2: 'ACTIVE TIME',
        unit0: 'steps',
        unit1: 'kcal',
        unit2: 'min',
        time0: 'WEEK',
        time1: 'MONTH',
        time2: 'YEAR',
        time3: 'DAY',
        math0: 'MAX',
        math1: 'AVG',
        math2: 'Target percentage',
        descTitle: 'CALORIES',
        desc: 'Sports energy consumption refers to the energy consumed during physical activity, calculated according to the type, time, intensity, etc., and does not include basic metabolism. (Basal metabolism refers to the minimum energy metabolism necessary to maintain the body\'s basic life activities such as body temperature, heartbeat, breathing, and blood circulation, which accumulates over time throughout the day.)',
        target: 'Target Progress',
        targetSet: 'Goal setting',
        targetDesc0: 'There are still ',
        targetDesc1: ' steps left to complete the goal, hurry up and move~',
        targetDesc2: ' kilocalories left to achieve the goal, hurry up and move on~',
        targetDesc3: ' min left to achieve the goal, hurry up and move on~',
        weekTitle: 'WEEKLY STATS',
        weekRatio: 'Step count',
        weekDesc0: 'This week you took ',
        weekDesc1: ' steps, which is equivalent to walking',
        weekDesc2: ' laps around a standard playground.',
        weekCalDesc0: 'This week you consumed ',
        weekCalDesc1: ' kcal, which is equivalent to ',
        weekCalDesc2: '.',
        weekDay: 'DAILY AVERAGE',
        weekDayDesc0: 'The daily average steps have ',
        weekDayDesc2: 'The daily average steps remain the same as the previous week.',
        weekDayCalDesc0: 'The daily energy consumption has increased by ',
        weekDayCalDesc2: 'Daily energy consumption remains the same as the previous week',
        weekDayAdd: 'increased ',
        weekDayReduce: 'decreased ',
        weekDayDesc1: ' steps compared to the previous week.',
        weekDayCalDesc1: ' kilocalories compared to the previous week.',
        monthTitle: 'MONTHLY STATS',
        monthTitleProp: '(This month\'s data does not include today\'s data)',
        monthDayDesc0: 'This month, you took an average of ',
        monthDayDesc1: ' steps per day, an ',
        monthDayDesc2: ' steps from last month.',
        monthDayDesc3: ' steps per day, which is the same as last month.',
        monthCalDayDesc0: 'This month, your daily average consumption is ',
        monthCalDayDesc1: ' kcal, an ',
        monthCalDayDesc2: ' kcal compared to last month.',
        monthCalDayDesc3: ' kcal, which is the same as last month.',
        monthSportStrengthDesc0: 'This month, your daily average active time is ',
        monthSportStrengthDesc1: ' min, an ',
        monthSportStrengthDesc2: ' min compared to last month.',
        monthSportStrengthDesc3: ' min, which is the same as last month.',
        monthThis: 'THIS MONTH',
        monthLast: 'LAST MONTH',
        monthReach: 'GOAL ACHIEVEMENT',
        monthReachDesc0: 'The number of days to achieve the target this month has',
        monthReachDesc1: ' days compared to last month.',
        monthReachDesc2: 'The number of days to achieve the target this month remains the same as last month.',
        stepTargetTitle: 'Target Steps',
        calTargetTitle: 'Target Calories',
        distance: 'DISTANCE',
        cal: 'CALORIES',
        distanceUnit: 'km',
        calUnit: 'kcal',
        abstract: 'INSIGHTS',
        more: 'VIEW MORE',
        all: 'TOTAL',
        weekReach: 'STANDARD DAYS',
        over: 'The goal has been achieved! Continue to persevere, and you will reap full of vitality and joy!',
        and: ' and ',
        stepToDC0: 'Equivalent to walking ',
        stepToDC1: ' laps around a standard playground and consuming ',
        stepToDC2: '.',
        calTCal0: 'Equivalent to consuming ',
        allCal: 'Total consumption',
        noAbstract: 'Insufficient data to display summary content~',
        allStrength: 'ALL TIME',
        strengthTitle: 'Moderate to high intensity active time',
        strengthDesc: 'Medium to high intensity activity time refers to the accumulated time of activity that reaches a medium to high intensity level based on step frequency (daily mode) or heart rate (exercise mode). It is usually recommended to reach 30 minutes per day.',
        monthAvg: 'AVG'
    },
    abstract: {
        title: 'Activity Summary'
    },
    hr: {
        title: 'HEART RATE',
        unit: 'bpm',
        resting: 'resting',
        time0: 'day',
        range: 'RANGE',
        avgHr: 'AVG HR',
        restingHr: 'RESTING HR',
        descTitle: 'RESTING HEART RATE',
        desc: 'Resting heart rate is the fasting heart rate before waking up in the morning, which is one of the important indicators for measuring heart health. The ideal resting heart rate is 60-80 beats per minute. People who are not within the ideal range have a higher probability of developing cardiovascular disease. By engaging in moderate intensity exercise, the resting heart rate can approach the ideal level.',
        desc1: 'This function is for reference only and does not serve as a medical diagnostic basis. If you experience any discomfort, please consult a medical institution immediately.',
        conclude: {
            "无有效结果": 'No result available;',
            "未见明显异常": 'No obvious abnormal;',
            "疑似房颤": 'No obvious abnormal;',
            "疑似心动过速": 'Suspected tachycardia;',
            "疑似心动过缓": 'Suspected bradycardia;',
            "疑似长RR间期": 'Suspected prolonged RR interval;',
            "疑似偶发室性早搏": 'Suspected accidental ventricular premature beats;',
            "疑似频发室性早搏": 'Suspected frequent ventricular premature beats;',
            "疑似室性心动过速": 'Suspected ventricular tachycardia;',
            "疑似偶发室上性早搏": 'Suspected accidental supraventricular premature beats;',
            "疑似频发室上性早搏": 'Suspected frequent supraventricular premature beats;',
            "疑似室上性心动过速": 'Suspected supraventricular tachycardia;'
        },
        suggest: {
            "心脏健康状况较好，请保持健康的生活习惯。": 'Your heart health is in good condition,please maintain a healthy lifestyle.',
            "请定期进行心电图监测，注意休息，保持生活规律。": 'Please schedule regular ECG monitoring,ensure adequate rest,and maintain a regular lifestyle.',
            "请定期进行心电图监测，留意心率和心律变化情况，注意休息，保持生活规律。": 'Please schedule regular ECG monitoring,pay attention to changes in heart rate and rhythm,ensure adequate rest and maintain a regular lifestyle.',
            "请定期进行心电图监测，如有心慌、胸闷、头晕、晕厥等症状，建议去正规医院咨询和检查。": 'Please schedule regular ECG monitoring.If you experience symptoms such as palpitations,chest tightness,dizziness,or fainting,it is recommended to consult and have a checkup at a hospital.',
            "请加强心电图监测，如有心慌、胸闷、头晕、晕厥等症状，请及时去正规医院咨询和诊疗。": 'Please enhance the frequency of your ECG monitoring.If you experience symptoms such as palpitations,chest tightness,dizziness,or fainting,please consult a doctor and seek medical attention promptly.',
            "心电波形质量较差，请重新测量！":"The poor quality of ECG waveform, please measure again!"
        }
    },
    hrDesc: {
        title: 'ARRHYTHMIA',
        title0: 'TACHYCARDIA',
        desc0: 'The percentage of instantaneous heart rate above 100 bpm. There are two types of tachycardia: physiologic and pathologic. Physiological tachycardia is the acceleration of the heart rate in the case of running, emotional excitement, etc. Tachycardia caused by high fever, anemia and other diseases is called pathological tachycardia.',
        title1: 'BRADYCARDIA',
        desc1: 'Instantaneous heart rate was less than 60 bpm as a percentage. There are several types of bradycardia, the most common being sinus bradycardia. A heart rate of less than 50 beats per minute is mostly pathological and usually requires treatment.',
        title2: 'ARRHYTHMIA OR PREMATURE BEAT',
        desc2: 'The proportion of sinus arrhythmia or premature beat rhythm. Premature beat, including ventricular premature beat and supraventricular premature beat, is a very common arrhythmia in clinical practice. It occurs in a wide range of people, including normal healthy people and various heart patients. Premature beats less than 5 beats per minute are sporadic, and more than 5 beats per minute are frequent.',
        title3: 'SUPRAVENTRICULAR PREMATURE BEAT',
        desc3: 'Supraventricular premature beat, which originates from premature excitation of the atrium outside the sinoatrial node, is a common arrhythmia seen in normal healthy people and in patients with any type of heart disease. The frequency of supraventricular premature beat increased with age. The main symptoms of supraventricular premature beat were palpitation and cardiac arrest. More than 5 beats per minute or more than 30 beats per hour are considered frequent supraventricular premature beats.',
        title4: 'VENTRICULAR PREMATURE BEAT',
        desc4: 'Ventricular premature beat refers to the heart rhythm disorder originating in the ventricles, is a very common arrhythmia, common in normal healthy people and various heart disease patients. In normal people, the frequency of ventricular premature increases with age. The most common symptom of ventricular premature beat is palpitations, and sometimes patients have a pounding sensation in the precardiac area and dizziness. More than 5 beats per minute or more than 30 beats per hour are considered frequent ventricular premature beats.',
        title5: 'ATRIAL FIBRILLATION',
        desc5: 'Atrial fibrillation, or atrial fibrillation, is the most common persistent arrhythmia that usually manifests as a fast, irregular heart rate. The incidence of atrial fibrillation is closely related to heart diseases such as coronary heart disease, hypertension and heart failure. The incidence of atrial fibrillation increases with age (up to 10% in people over 75 years old), and may lead to serious complications such as stroke.',
        title6: 'LONG RR INTERVAL',
        desc6: 'Long RR interval generally refers to the RR interval greater than or equal to 1.5s in the electrocardiogram, which is one of the important monitoring indicators in the holter electrocardiogram. The most common types of arrhythmias causing long RR intervals include atrial fibrillation or flutter, sinus arrest, and atrioventricular block.',
    },
    ecgDesc: {
        title: 'HEART HEALTH SCORE',
        title0: 'HEART HEALTH SCORE',
        desc0: 'The heart health score, calculated according to the rhythm analysis and arrhythmic events calculated from this ECG measurement and according to a certain weighting strategy, if fewer arrhythmic events and rhythm abnormalities are found that means the heart health score is higher, and vice versa, the specific score control is as follows:',
        level0: 'BAD：＜60',
        level1: 'WEAK：60-69',
        level2: 'AVERAGE：70-79',
        level3: 'GOOD：80-89',
        level4: 'GREAT：≥90',
        title1: 'CONCLUSIONS AND RECOMMENDATIONS',
        desc1: 'It is automatically generated based on arrhythmia events and abnormal rhythm events for reference only, and is not directly used as a basis for clinical diagnosis. For users who are at risk or have physical discomfort, it is recommended to go to a regular medical institution for further consultation and examination in time.'
    },
    hrvDesc: {
        title: 'HRV INDEX',
        title0: 'HRV INDEX',
        desc0: 'HRV index, i.e. heart rate variability, refers to the change of heart rate rhythm over time, which is used to analyze the subtle time change of each cardiac cycle and its regularity, mainly reflecting the autonomic nerve\'s ability to regulate the heart. The higher the HRV, the better the regulation of the cardiovascular system by the nerves. If the HRV is poor, you should pay attention to rest and emotional control, and if you have any problems such as cardiac discomfort, please consult a doctor for examination in a timely manner, and the specific scores are compared as follows:',
        level0: 'BAD：0-21',
        level1: 'AVERAGE：21-34',
        level2: 'GOOD：34-47',
        level3: 'GREAT：>47',
    },
    sleep: {
        title: 'SLEEP',
        time0: 'day',
        time1: 'week',
        time2: 'month',
        fallAsleep: 'Fall asleep',
        wakeUp: 'Wake up',
        level0: 'GREAT',
        level1: 'AVERAGE',
        level2: 'BAD',
        hour: 'h',
        minute: 'min',
        sleepStage: 'SLEEP STAGE',
        stage0: 'DEEP',
        stage1: 'LIGHT',
        stage2: 'REM',
        stage3: 'WAKE',
        mathTitle: 'Sleep statistics',
        math0: 'AVG.SLEEP',
        math1: 'MIN.SLEEP',
        math2: 'MAX.SLEEP',
        ratioLevel0: 'Deep sleep ratio (reference: 20~60%)',
        ratioLevel1: 'Light sleep ratio (reference:<55%)',
        ratioLevel2: 'REM ratio (reference: 10~30%)',
        ratioLevel3: 'Wake frequency (reference: ≤ 1 time)',
        ratioLevel4: 'Short Nap',
        ratioNormal: 'NORMAL',
        ratioHigh: 'HIGH',
        ratioLow: 'LOW',
        sportLevel: 'Strength',
        other: 'SUGGESTION',
        other0: 'You sleep earlier than ',
        other1: ' of users',
        other2: 'You wake up earlier than ',
        other3: ' of users',
        stageTitle: 'Installment statistics',
        stageKey0: 'AVG. DEEP SLEEP',
        stageKey1: 'AVG. LIGHT SLEEP',
        stageKey2: 'AVG. REM SLEEP',
        stageKey3: 'AVG. AWAKE TIME',
        fallTitle: 'SLEEP ONSET',
        dayTitle: 'DAILY AVERAGE',
        averageDesc0: 'The average daily sleep duration this Sunday',
        averageDesc1: 'The average daily sleep duration this month',
        averageDesc2: ' has increased by ',
        averageDesc3: ' has decreased by ',
        averageDesc5: ' remains the same as last month.',
        averageDesc4: ' compared to',
        averageDesc6: ' last week.',
        averageDesc7: ' last month.',
        scoreTitle: 'SLEEP SCORE',
        total: 'Total sleep duration',
        duration: 'DURATION',
        typical: 'TYPICAL RANGE',
        week1: 'Mon',
        week2: 'Tue',
        week3: 'Wed',
        week4: 'Thu',
        week5: 'Fri',
        week6: 'Sat',
        week0: 'Sun',
        ahiNormal: 'NORMAL',
        ahiMild: 'MILD',
        ahiModerate: 'MODERATE',
        ahiSevere: 'SEVERE',
        avgScore: 'AVG SCORE',
        vsLastWeek: '(VS Last Week)',
        vsLastMonth: '(VS Last Month)',
        vsLastWeekTitle: 'VS. LAST WEEK',
        vsLastMonthTitle: 'VS. LAST MONTH',
        days: ' days',
        scoreGe80: '(≥80)',
        score60to79: '(60~79)',
        scoreLe60: '(＜60)',
        suggestText: 'Great job this week! Sleep quality improved this week. Let\'s keep it going.',
        hoursVsNeed: 'HOURS OF SLEEP VS. NEED',
        sleepEfficiency: 'SLEEP EFFICIENCY',
        avgSleepEfficiency: 'AVG SLEEP EFFICIENCY',
        sleepConsistency: 'SLEEP CONSISTENCY',
        avgRestorativeSleep: 'AVG RESTORATIVE SLEEP',
        sleepStability: 'SLEEP STABILITY',
        avgSleepStability: 'AVG SLEEP STABILITY',
        ahi: 'AHI',
        avgAhi: 'AVG AHI',
    },
    sleepShort: {
        title: 'Details',
        shortTitle: 'Short Nap',
        shortDesc: 'Any single sleep session lasting less than 3 hours but equal to or longer than 40 minutes is counted as a short nap. Sleep stage analysis is currently not supported for short naps.',
        suggest: 'Nap Suggestions',
        suggest0: 'Choose appropriate nap times',
        suggest1: '1. Best in early afternoon: For most people, the period between 1-3 PM is ideal for napping as the body\'s biological clock naturally enters a fatigue trough during this time. A nap can effectively relieve fatigue from morning work or study, and there\'s still sufficient time before nighttime sleep, typically without disrupting nocturnal rest.',
        suggest2: '2. Avoid late naps: Try not to nap after 3 PM, and especially avoid napping after 5 PM, as this may disrupt normal sleep rhythms and make it difficult to fall asleep at night.',
    },
    sleepStage: {
        title: 'SLEEP STAGE',
        desc0: 'Sleep stages are for the convenience of research and according to the brain waves and physiological performance of artificial delineation, in fact, it is difficult to draw a clear line between the various sleep stages, often gradually change, overlap, and each has its own focus. People\'s sleep, there are about 4 to 6 sleep cycles in a night, connected with each other, and repeat. Ensuring adequate sleep every day is very beneficial for maintaining physical and mental health, research shows that the appropriate sleep duration for adults is: 6-10 hours, sleep time is not the only standard for sleep quality, long sleep may not make up for lack of sleep, and sometimes it is not conducive to getting high-quality sleep, we should reasonable rest and rest time to improve sleep quality.',
        title1: 'DEEP SLEEP STAGE',
        desc1: 'Brain wave frequency is significantly slower, respiratory rate and blood pressure are also significantly reduced, the brain can get a full rest, in the deep sleep stage will be awakened dizziness, palpitations, irritability and other symptoms, the longer the deep sleep time, the better the quality of sleep, if the deep sleep for too long may be a signal of some diseases, it is recommended to find a professional doctor consultation.',
        title2: 'LIGHT SLEEP STAGE',
        desc2: 'Brain waves slow down, heart rate and breathing speed slow down, people enter sleep but easy to wake up, light sleep is a normal phenomenon, help people wake up quickly, but if the proportion of light sleep is too large, sleep quality can not be guaranteed, easy to appear sleepy.',
        title3: 'RAPID EYE MOVEMENT STAGE',
        desc3: 'People\'s eyes move back and forth quickly, and people are generally in a dream at this stage. In order to avoid people making movements in dreams, the muscles will be relaxed and paralyzed.',
        title4: 'WAKING PHASE',
        desc4: 'Night awake is not really awake, people may not realize that they have woken up, in a critical state of awakening, under normal circumstances, the total wake time is less than 10% of the total sleep time, night awake time and too many times may be caused by insomnia, it is recommended to find a professional doctor consultation.',
    },
    bos: {
        title: 'SpO2',
        time0: 'day',
        time1: 'week',
        time2: 'month',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        level0: 'Normal',
        level1: 'Mild Hypoxemia',
        level2: 'Moderate Hypoxemia',
        descTitle: 'SpO2',
        desc0: 'SpO2 is the volume of oxygen-bound oxyhemoglobin (HbO2) in the blood as a percentage of the volume of all bindable hemoglobin, i.e., the concentration of blood oxygen in the blood, which is an important physiological parameter of the respiratory cycle.',
        desc1: 'The results showed that the blood oxygen value was',
        desc2: '95%-100% normal',
        desc3: '90-94% mild Hypoxemia',
        desc4: '70-89% moderate hypoxemia',
        desc5: 'This function is for reference only, not as a basis for medical diagnosis, if you feel uncomfortable, please consult the medical institution immediately.'
    },
    pressure: {
        title: 'STRESS',
        time0: 'day',
        time1: 'week',
        time2: 'month',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        level0: 'High',
        level1: 'Moderate',
        level2: 'Normal',
        level3: 'Rest',
        descTitle: 'STRESS',
        desc0: 'This device is based on HRV (heart rate variation rate) and other data, through the algorithm to get the current pressure value. Through the pressure value, you can understand your physical pressure state, and when you are under high pressure, timely decompression is conducive to good health.',
        desc1: 'Value Explanation：',
        desc2: '1~29 Rest',
        desc3: '30~59 Normal',
        desc4: '60~79 Moderate',
        desc5: '80~99 High'
    },
    fitnessAge: {
        title: 'FITNESS AGE',
        time0: 'week',
        time1: 'month',
        unit: 'age',
        actualAge: 'Actual age',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        descTitle: 'FITNESS AGE',
        desc: 'Fitness age is calculated from your VO2 Max. This indicator indicates that during exercise, the body can achieve the maximum oxygen uptake rate that can be used by the muscles. In general, the higher the VO2max, the better the aerobic capacity.'
    },
    staminaLevel: {
        title: 'STAMINA LEVEL',
        time0: 'week',
        time1: 'month',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        level0: 'Novice',
        level1: 'Beginner',
        level2: 'Challenger',
        level3: 'Exerciser',
        level4: 'SpoLover',
        level5: 'Sport Enthusiast',
        level6: 'Athlete',
        descTitle: 'STAMINA LEVEL',
        unit0: 'stamina level',
        unit1: 'aerobic',
        unit2: 'anaerobic',
        desc0: 'Stamina Level can reflect the potential of sports performance in the best state and is a comprehensive index. The aerobic fitness level can be used to judge your ability to perform over medium and long distances, and the anaerobic fitness level can be used to judge your ability to perform over short and medium distances.',
        desc1: 'Description of stamina level values：',
        desc2: '10-19.9 Novice',
        desc3: '20-29.9 Beginner',
        desc4: '30-39.9 Challenger',
        desc5: '40-49.9 Exerciser',
        desc6: '50-59.9 SpoLover',
        desc7: '60-69.9 Sport Enthusiast',
        desc8: '70-80.9 Athlete',
    },
    trainingLoad: {
        title: 'TRAINING LOAD TREND',
        time0: 'week',
        time1: 'month',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        level0: 'Low',
        level1: 'Optimum',
        level2: 'High',
        descTitle: 'TRAINING LOAD TREND',
        desc0: 'The training load trend reflects the current load of the body, so that the intensity and time of the training session can be adjusted before exercise to achieve the best training schedule and reduce the risk of injury.',
        desc1: 'Description of training load trend values：',
        desc2: '＜0.8 Low',
        desc3: '0.8-1.5 Optimum',
        desc4: '＞1.5 High'
    },
    trainingStatus: {
        title: 'TRAINING STATUS',
        time0: 'week',
        time1: 'month',
        level0: 'No Status',
        level1: 'Overreaching',
        level2: 'Detraining',
        level3: 'Unproductive',
        level4: 'Maintaining',
        level5: 'Recovery',
        level6: 'Productive',
        level7: 'Peaking',
        descTitle: 'TRAINING STATUS',
        desc0: 'Training status is a training status indicator for evaluating running or cycling. Observing the change trend of training load and physical strength level in the past 7 days can provide training guidance for subsequent exercise training.',
        desc1: 'Stateless period: No training in the past 7 days or less than 7 days since the first training',
        desc2: 'Overtraining period: It is recommended to reduce the training load and increase the recovery time',
        desc3: 'Stop training period: It is recommended to start training to achieve positive training adaptation',
        desc4: 'Regression period: It is recommended to review the training plan and adjust the training load',
        desc5: 'Maintenance period: It is recommended to increase the training load to achieve positive training adaptation',
        desc6: 'Recovery period: It is recommended to increase the training load appropriately to avoid a decline in fitness level',
        desc7: 'Progress period: It is recommended to maintain the current training status',
        desc8: 'Downsizing period: It is recommended to pay attention to fitness level changes to fine-tune the training load',
    },
    vo2max: {
        title: 'VO2 Max',
        time0: 'week',
        time1: 'month',
        level0: 'Very Poor',
        level1: 'Poor',
        level2: 'Fair',
        level3: 'Good',
        level4: 'Excellent',
        level5: 'Superior',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        descTitle: 'VO2 Max',
        desc: 'VO2 Max can be defined as the highest rate at which oxygen is absorbed and utilized by the body during strenuous exercise. It is often used to represent an individual\'s cardiorespiratory fitness.',
        age: 'Age'
    },
    lactate: {
        title: 'LT',
        time0: 'week',
        time1: 'month',
        math0: 'MAX',
        math1: 'MIN',
        math2: 'AVG',
        descTitle: 'LT',
        unit0: 'km',
        unit1: 'bpm',
        type0: 'Pace',
        type1: 'HR',
        desc0: 'Lactate threshold pace is the fastest running pace at the lactate concentration that the body can tolerate during exercise (approximately 88-92% of the maximum heart rate).',
        desc1: 'Maximum Lactate Steady State (MLSS) is reached during exercise, and the lactate threshold heart rate occurs at this stage, generally falling at 88-92% of the maximum heart rate, below which exercise intensity indicates the ability to continue exercising for long periods of time without fatigue.'
    },
    forecast: {
        title: 'BEST RUN TIME',
        title0: 'Latest achievement',
        level2: 'Half marathon',
        level3: 'Marathon',
        title1: 'Best performance',
        descTitle: 'Best Run Time',
        desc: 'Based on the user\'s fitness level state, it can estimate the best performance that an individual can achieve at different distances and monitor the improvement of your running performance over a longer period of time.',
        prot: 'Date'
    },
    basicHr: {
        title: 'BASIC HR',
        time0: 'week',
        time1: 'month',
        unit: 'bpm',
        math0: 'Max',
        math1: 'Min',
        math2: 'Avg',
        descTitle: 'BASIC HR',
        desc: 'Basal heart rate is the fasting heart rate before getting up in the morning, which is one of the important indicators of heart health. The ideal basic heart rate is 50 to 80 bpm, people who are not in the ideal range have a higher probability of cardiovascular disease, and the basic heart rate can be ideal by carrying out appropriate intensity exercise.',
        desc0: 'This function is for reference only and does not serve as a medical diagnostic basis. If you experience any discomfort, please consult a medical institution immediately.',
    },
    sportType: {
        "其他": 'Other',
        "全部运动": 'All sports',
        "健走": 'Walk',
        "跑步": 'Run',
        "骑行": 'Bike',
        "室内游泳": 'Pool Swim',
        "户外游泳": 'Open Water Swim',
        "操场跑": 'Track run',
        "徒步越野": 'Hike',
        "徒步穿越": 'Hike',
        "马拉松": 'Marathon',
        "铁人三项": 'Triathlon',
        "深蹲": 'Squats',
        "划船机": 'Rower',
        "椭圆机": 'Elliptical',
        "卷腹": 'Crunches',
        "自由训练": 'Strength',
        "跳绳": 'Jump rope',
        "俯卧撑": 'Push-ups',
        "平板支撑": 'Plank',
        "室内跑": 'Treadmill',
        "射箭": 'Archery',
        "拳击": 'Boxing',
        "爬楼": 'Floor Climb',
        "越野跑": 'Trail run',
        "登山": 'Mtn Climb',
        "轮滑": 'Inline Skating',
        "骑马": 'Horseback',
        "皮划艇": 'Kayak',
        "冲浪": 'Surf',
        "帆板": 'Windsurf',
        "越野骑行": 'Cross-Country Bike',
        "越野滑雪": 'Cross-Country Skiing',
        "滑雪登山": 'Ski Mountaineering',
        "室内攀岩": 'Indoor Climb',
        "户外攀岩": 'Outdoor Climb',
        "飞盘": 'Frisbee',
        "跳伞": 'Parachuting',
        "篮球": 'Basketball',
        "足球": 'Soccer',
        "网球": 'Tennis',
        "羽毛球": 'Badminton',
        "乒乓球": 'Table Tennis',
        "力量训练": 'Strength Training',
        室内步行: 'Indoor Walking',
        障碍赛跑: 'Obstacle Course Racing',
        越野摩托: 'Motocross',
        摩托艇: 'Powerboating',
        漂流: 'Rafting',
        风筝冲浪: 'Kiteboarding',
        滑水: 'Water Skiing',
        浮潜: 'Snorkeling',
        赛艇: 'Rowing',
        龙舟: 'Dragon Boating',
        跳水: 'Diving',
        有氧运动: 'Aerobic Exercise',
        室内单车: 'Indoor Cycling',
        踏步机: 'Stair Stepper',
        爬楼机: 'Stair Climber',
        漫步机: 'Elliptical Walker',
        瑜伽: 'Yoga',
        普拉提: 'Pilates',
        空手道: 'Karate',
        跆拳道: 'Taekwondo',
        HIIT: 'HIIT',
        体操: 'Gymnastics',
        单杠: 'Horizontal Bar',
        双杠: 'Parallel Bars',
        户外滑冰: 'Outdoor Skating',
        室内滑冰: 'Indoor Skating',
        单板滑雪: 'Snowboarding',
        双板滑雪: 'Skiing',
        冰壶: 'Curling',
        雪地摩托: 'Snowmobiling',
        雪橇: 'Sledding',
        雪车: 'Bobsleigh',
        雪鞋徒步: 'Snowshoeing',
        蹦极: 'Bungee Jumping',
        跑酷: 'Parkour',
        BMX: 'BMX',
        赛车: 'Auto Racing',
        水球: 'Water Polo',
        排球: 'Volleyball',
        棒球: 'Baseball',
        橄榄球: 'Rugby',
        曲棍球: 'Hockey',
        门球: 'Gateball',
        板球: 'Cricket',
        台球: 'Billiards',
        保龄球: 'Bowling',
        匹克球: 'Pickleball',
        壁球: 'Squash',
        垒球: 'Softball',
        冰球: 'Ice Hockey',
        手球: 'Handball',
        舞蹈: 'Dance',
        太极拳: 'Tai Chi',
        健身操: 'Aerobics',
        武术: 'Martial Arts',
        击剑: 'Fencing',
        滑板: 'Skateboarding',
        摔跤: 'Wrestling',
        钓鱼: 'Fishing',
        体感游戏: 'Motion-Sensing Games'
    },
    challengeType: {
        type: 'Individual tournament',
        attribute0: {
            name: 'Time Challenge',
            attribute: 'Time race',
            desc0: 'During the challenge period, the accumulated mileage reached ',
            desc1: ' kilometers, and the shorter the time, the higher the ranking. (Please synchronize data in a timely manner after exercise, and the ranking list will be updated in real time)'
        },
        attribute1: {
            name: 'Distance Challenge',
            attribute: 'Distance race',
            desc: 'During the challenge cycle, the longer the cumulative distance of sport, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        "attribute1骑行": {
            name: 'Cycling Distance',
            attribute: 'Distance race',
            desc: 'During the challenge cycle, the longer the cumulative distance traveled, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        "attribute1跑步": {
            name: 'Running Distance',
            attribute: 'Distance race',
            desc: 'During the challenge period, the longer the accumulated distance of running, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        attribute2: {
            name: 'Fat Burner',
            attribute: 'Fat burner',
            desc: 'During the challenge period, the more calories burned during a designated exercise, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        attribute3: {
            name: 'Speed Challenge',
            attribute: 'Speed race',
            desc: 'During the challenge period, the faster the average pace of a single sport, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        "attribute3骑行": {
            name: 'Cycling Speed',
            attribute: 'Speed race',
            desc: 'During the challenge period, the faster the average pace of a single ride, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        "attribute3跑步": {
            name: 'Running Speed',
            attribute: 'Speed race',
            desc: 'During the challenge period, the faster the average pace of a single run, the higher the ranking. (Please synchronize data in a timely manner after exercising, and the ranking list will be updated in real time)'
        },
        attribute4: {
            name: 'Step Challenge',
            attribute: 'Step race',
            desc: 'Within the specified sports mode, the higher the number of steps, the higher the ranking (please synchronize data in a timely manner after exercise, and the ranking list will be updated in real time)',
        }
    },
    challengeList: {
        title: 'Challenge',
        history: 'Historical',
        join: 'Joined'
    },
    challengeDesc: {
        medalPop: 'Congratulations on your',
        accept: 'Accept',
        over: 'Over',
        join: 'Joined',
        no0: 'No.',
        no1: '',
        end0: 'To the end',
        end1: 'days',
        rDistance0: 'Spare distance',
        distanceUnit: 'KM',
        tDistance: 'Total distance',
        race: 'Fastest pace',
        cal: 'Total calories',
        calUnit: 'Kcal',
        step: 'Total steps',
        stepUnit: '',
        down: 'Click to open',
        up: 'Pull up to close',
        range: 'Range',
        type: 'Type',
        typeValue: 'Single',
        attribute: 'Attribute',
        attributeArr: ['Time race', 'Distance race', 'Fat burner', 'Speed race', 'Step race'],
        sport: 'Sport',
        tab0: 'Details',
        tab1: 'Rankings',
        descTitle: 'Contest Description',
        top3: 'Medals',
        medalFinish: 'Ranking',
        noMedal: 'Did not get the medal, next time work hard~',
        joining: 'Join now',
        tableTitle0: 'Rank',
        tableTitle1: 'User',
        tableTitle2: 'Remaining',
        tableTitle3: 'Duration',
        tableTitle4: 'Distance',
        tableTitle5: 'Calories',
        tableTitle6: 'Pace',
        tableTitle7: 'Steps',
    },
    sportRecord: {
        title: 'Sports Records',
        record0: {
            name: 'Step',
            record0: 'Single-day record',
            record1: 'Single-week record',
            record2: 'Single-month record'
        },
        record1: {
            name: 'Run',
            record0: 'Maximum distance(KM)',
            record1: 'Optimal pace',
        },
        record2: {
            name: 'Ride',
            record0: 'Maximum distance(KM)',
            record1: 'Optimal pace',
        },
        record3: {
            name: 'Swim',
            record0: 'Maximum distance(KM)',
            record1: 'Optimal SWOLF',
        },
        record4: {
            name: 'Climb',
            record0: 'Maximum height(m)',
        }
    },
    sportCount: {
        title: 'Sports statistics',
        time0: 'week',
        time1: 'month',
        unit0: 'KM',
        unit1: 'minute',
        item1: 'Number',
        item1Unit: 'time',
        item2: 'Duration',
        item2Unit: 'hour',
        item3: 'Total distance',
        item4: 'Total calories',
        item4Unit: 'Kcal'
    },
    newSportList: {
        title: 'Campaign Report',
        type0: 'Weekly',
        type1: 'Monthly',
        type2: 'Yearly',
    },
    newWeek: {
        title: 'Sports Weekly',
        stepDesc0: 'Beat ',
        stepDesc1: 'this week',
    },
    newMonth: {
        title: 'Sports Monthly',
        noMedal: 'Nothing! Keep trying~',
        add0: 'Add',
        add1: '',
        more0: 'Beat',
        more1: 'of people'
    },
    newWeekHistory: {
        title: 'Weekly History Report',
        no: 'There\'s nothing down there.'
    },
    newMonthHistory: {
        title: 'Monthly History Report',
        no: 'There\'s nothing down there.'
    },
    feedback: {
        title: 'Feedback',
        prop: 'Please describe the problems you\'re experiencing or make suggestions for optimization, and we\'ll be sure to take them seriously!',
        contact: 'Contact',
        contactValue: 'Phone/QQ/Wechat/Email',
        submit: 'Submit'
    },
    medal: {
        title: 'My Medals',
        tab0: 'Sport',
        tab1: 'BeiDou',
        tab2: 'Challenge',
        get0: '',
        get1: 'medals have been awarded',
        step: 'Step',
        run: 'Run',
        ride: 'Ride',
        swim: 'Swim',
        climb: 'Mtn Climb',
        marathon: 'Marathon',
        sport: 'Sport'
    },
    selectCityApp: {
        title: 'Select City',
        current: 'Current City',
        placeholder: 'Please enter the city name '
    },
    prodInstructions: {
        title: 'Operating Instructions',
        video: 'Video',
        desc: 'Manual',
        quick: 'Quick Start',
        question: 'FAQs',
        compass700: 'The compass is inaccurate?',
        compass: 'The compass is inaccurate?',
        sleep: 'No sleep data?',
        height: 'Inaccurate altitude?',
        ecg: 'ECG cannot be measured/inaccurate results?',
        android: 'Android messages won\'t push to watch?',
        ios: 'iOS messages won\'t push to watch?',
        keepAlive: 'How to make a keep-alive setting?',
        restricted: 'Phone open permissions prompt "Restricted Settings"?',
        map: 'How to download maps?'
    },
    keepAlive: {
        title: 'Live setup',
        desc: 'In order to ensure that Aswear Global can run normally in the background and that the Bluetooth connection is stable, users can refer to the following corresponding models to set up.',
        tabArr: ['Xiaomi', 'Huawei', 'vivo', 'OPPO', 'OnePlus', 'realme', 'HONOR', 'lenovo', 'Meizu', 'Samsung'],
        xiaomi: {
            p0: '1 Xiaomi',
            p1: '1.1 Xiaomi phones allow background activity',
            p2: 'Click on Settings - 【Settings】- 【Apps】- 【App management】- 【Aswear Global】- 【Battery saver】- Set to【No restrictions】.',
            p3: '1.1.1 Apps',
            p4: '1.1.2 App management',
            p5: '1.1.3 Aswear Global',
            p6: '1.1.4 Battery saver',
            p7: '1.1.5 Set to【No restrictions】',
            p8: '1.2 Xiaomi phone autostart settings',
            p9: 'Click on Settings -【Settings】-【Apps】-【App management】-【Aswear Global】- 【Autostart】- Turn on【Autostart】.',
            p10: '1.2.1 Apps',
            p11: '1.2.2 App management',
            p12: '1.2.3 Aswear Global',
            p13: '1.2.4 Turn on【Autostart】',
            p14: '1.3 Lock background tasks',
            p15: '①Tap the bottom swipe-up hover to bring up background tasks；',
            p16: 'Long press the "Aswear Global" app and tap the "lock" icon to lock the app.'
        },
        huawei: {
            p0: '2 Huawei',
            p1: '2.1 Huawei phone locks background tasks',
            p2: 'Swipe up from the bottom of the screen - Go to the multitasking page - find Aswear Global - Scroll down Aswear Global - Locked Aswear Global.',
            p3: '2.2 Huawei phones allow background activity',
            p4: 'Click on Settings - 【Settings】- 【Apps & services】- 【App startup management】- 【Aswear Global】-【Allow background activity】',
            p5: '2.2.1 Apps & services',
            p6: '2.2.2 App startup management',
            p7: '2.2.3 Aswear Global',
            p8: '2.2.4 Allow background activity',
            p9: '2.2.5 Click Confirm'
        },
        vivo: {
            p0: '3 vivo',
            p1: '3.1 vivo phones allow background activity',
            p2: 'Click on Settings -【Battery】- 【Background high battery usage】- 【Aswear Global】, open【Background high battery usage】.',
            p3: '3.1.1 Battery',
            p4: '3.1.2 Battery',
            p5: '3.1.3 Aswear Global',
            p6: '3.1.4 open switch',
            p7: '3.2 vivo phone self-start permission settings',
            p80: 'Recommended operation: Search for "self start" in the "Phone Settings", enter the self start management page, select "Enable this APP to allow self start".',
            p8: 'Click on Settings -【Apps and permissions】-【Permissions】-【Autostart】.',
            p9: '3.2.1 Apps and permissions',
            p10: '3.2.2 Permissions',
            p11: '3.2.3 Autostart'
        },
        oppo: {
            p0: '4 OPPO',
            p1: '4.1 OPPO phones allow background activity',
            p2: 'Click on Settings - 【Battery】- 【App battery management】- 【Aswear Global】, open【Allows full background behavior】- Click 【Allow】.',
            p3: '4.1.1 Battery',
            p4: '4.1.2 App battery management',
            p5: '4.1.3 Aswear Global',
            p6: '4.1.4 Allows full background behavior',
            p7: '4.1.5 Click allow',
            p8: '4.2 OPPO phone self-start permission settings',
            p9: 'Click on Settings -【App management】-【Autostart management】- open【Aswear Global】.',
            p10: '4.2.1 App management',
            p11: '4.2.2 Autostart management',
            p12: '4.2.3 Turn on Aswear Global'
        },
        yijia: {
            p0: '5 OnePlus',
            p1: '5.1 OnePlus phone locks background tasks',
            p2: 'Swipe up from the bottom of the screen - Go to the Multitasking page - Find Aswear Global - Tap the More button - Tap to lock Aswear Global.',
            p3: '5.2 OnePlus phones allow background activity',
            p4: 'Click on Settings - 【Battery】- 【App battery management】- 【Aswear Global】, Turn on 【Allows full background behavior】- Click【Allow】.',
            p5: '5.2.1 Battery',
            p6: '5.2.2 App battery management',
            p7: '5.2.3 Aswear Global',
            p8: '5.2.4 Allows full background behavior',
            p9: '5.2.5 Click Allow',
            p10: '5.3 OnePlus phone self-start permission settings',
            p11: 'Click on Settings -【App management】-【Autostart management】-【Aswear Global】- Turn on【Aswear Global】.',
            p12: '5.3.1 App management',
            p13: '5.3.2 Autostart management',
            p14: '5.3.3 Aswear Global'
        },
        realme: {
            p0: '6 realme',
            p1: '6.1 realme phone locks background tasks',
            p2: 'Swipe up from the bottom of the screen - Go to the Multitasking page - Find Aswear Global - Tap the More button - Tap to lock Aswear Global.',
            p3: '6.2 realme phones allow background activity',
            p4: 'Click on Settings -【Battery】-【App battery management】-【Aswear Global】, Turn on 【Allows full background behavior】- Click【Allow】.',
            p5: '6.2.1 Battery',
            p6: '6.2.2 App battery management',
            p7: '6.2.3 Aswear Global',
            p8: '6.2.4 Allows full background behavior',
            p9: '6.2.5 Click Allow',
            p10: '6.3 realme phone self-start permission settings',
            p11: 'Click on Settings -【App management】-【Autostart management】-【Aswear Global】- Turn on【Aswear Global】.',
            p12: '6.3.1 App management',
            p13: '6.3.2 Autostart management',
            p14: '6.3.3 Aswear Global'
        },
        rongyao: {
            p0: '7 HONOR',
            p1: '7.1 HONOR phone locks background tasks',
            p2: 'Swipe up from the bottom of the screen - Go to the multitasking page - Find Aswear Global - Swipe down on Aswear Global - Lock Aswear Global.',
            p3: '7.2 HONOR phones allow background activity',
            p4: 'Click on Settings -【Apps and services】-【App startup management】-【Aswear Global】, Turn on 【Allows background activity】- Click【Confirm】.',
            p5: '7.2.1 Apps and services',
            p6: '7.2.2 App startup management',
            p7: '7.2.3 Aswear Global',
            p8: '7.2.4 Allows background activity',
            p9: '7.2.5 Click Confirm'
        },
        lianxiang: {
            p0: '8 lenovo',
            p1: '8.1 lenovo phones allow background activity',
            p2: 'Click on Settings - 【Apps and notifications】- 【Special apps management】- 【Battery optimization】- 【Aswear Global】, select【Not optimized】, click 【Finished】.',
            p3: '8.1.1 Apps and notifications',
            p4: '8.1.2 Special apps management',
            p5: '8.1.3 Battery optimization',
            p6: '8.1.4 Aswear Global',
            p7: '8.1.5 Select Not optimized',
            p8: '8.1.6 Click Finished',
            p9: '8.2 lenovo phone self-start permission settings',
            p10: 'Click on Settings -【Apps and notifications】-【View all apps】-【Aswear Global】-【Permissions】-【Autostart】, select【Permit】.',
            p11: '8.2.1 Apps and notifications',
            p12: '8.2.2 View all apps',
            p13: '8.2.3 Aswear Global',
            p14: '8.2.4 Permissions',
            p15: '8.2.5 Autostart',
            p16: '8.2.6 Select Permit'
        },
        meizu: {
            p0: '9 Meizu',
            p1: '9.1 Meizu phones allow background activity',
            p2: 'Click on Settings - 【Privacy and permission】- 【Background management】- 【Aswear Global】, select【Allow background activity】.',
            p3: '9.1.1 Privacy and permission',
            p4: '9.1.2 Background management',
            p5: '9.1.3 Aswear Global',
            p6: '9.1.4 Select Allow background activity',
            p7: '9.2 Meizu phone locks background tasks',
            p8: 'Swipe up from the bottom of the screen - Go to the Multitasking page - Find Aswear Global - Swipe down on Aswear Global - Tap to lock Aswear Global.'
        },
        sanxing: {
            p0: '10 Samsung',
            p1: '10.1 Samsung phone locks background tasks',
            p2: 'Swipe up from the bottom of the screen - Go to the multitasking page - Find Aswear Global - Long press Aswear Global - Tap to lock Aswear Global.',
            p3: '10.2 Samsung phones allow background activity',
            p4: 'Click on Settings - 【Apps】- 【Aswear Global】- 【Battery】, Turn on【Allow background activity】.',
            p5: '10.2.1 Apps',
            p6: '10.2.2 Aswear Global',
            p7: '10.2.3 Battery',
            p8: '10.2.4 Allow background activity',
            p9: '10.3 Samsung phone self-start permission settings',
            p10: 'Click on Settings -【General management】-【Battery】-【Background usage restriction】-【Run the app automatically】- Turn on【Aswear Global】.',
            p11: '10.3.1 General management',
            p12: '10.3.2 Battery',
            p13: '10.3.3 Background usage restriction',
            p14: '10.3.4 Run the app automatically',
            p15: '10.3.5 Turn on Aswear Global',
            p16: '【More knowledge】',
            p17: 'The solution to the “Restricted Settings” message when opening permissions on cell phones'
        }
    },
    androidMessageSet: {
        title: 'Messages not being pushed to watch?',
        p0: 'Message Push Principle:',
        p1: 'After the watch is connected to your Android phone, the system gets notifications from your phone\'s notification bar and pushes them to your watch.',
        p2: 'If you find that your watch is not receiving messages from the corresponding',
        p3: 'application',
        p4: ', take',
        p5: 'WeChat',
        p6: 'as an example, please try the following operation:',
        p7: '1. Go to your phone\'s settings, search and enter the',
        p8: '“Permissions>upper right>Special Permissions>Notifications access>Aswear Global APP”',
        p8end: '.',
        p9: '2. In',
        p10: '“Aswear Global APP>My Device>Message Alert”',
        p11: ', and turn on the switch of the app that needs to push message.',
        p12: '3. Ensure that messages can be displayed in the notification bar of your phone: Take Huawei HarmonyOS 3.0 phone as an example, select ',
        p13: '“Settings > Notifications & status Bar”',
        p14: ', click the app you need to notify, set it to',
        p15: 'Allow notifications',
        p16: ', and set the notification method for each type of message of the app (ringtone, vibration, banner, lock screen notification, allow to disturb, or desktop icon corner icon, etc.), and',
        p17: ' turn off the silent notification switch',
        p18: '.',
        p19: '①Enter the',
        p20: 'notifications & status bar',
        p21: '②Turn on the notification switch of the corresponding application (WeChat is an example)',
        p22: '③Turn on',
        p23: 'Allow notifications',
        p24: 'Switch ④ Other categories of message notification settings (take new message notification as an example: turn on',
        p25: 'Allow notifications',
        p26: 'and',
        p27: 'Allow to disturb',
        p28: ', and turn off',
        p29: 'Silent Notification',
        p30: ').',
        p31: '4. If WeChat messages are not pushed or message details are not displayed, please open WeChat, select',
        p32: '“Settings>Message Notifications>New Message Alert”',
        p33: ', and turn on the',
        p34: 'Receive New Message Notification',
        p35: 'and',
        p36: 'Notify Message Details',
        p37: 'switches to ensure that WeChat messages can be successfully displayed in the status bar of the phone.',
        p38: '①Enter',
        p39: 'new message notification',
        p40: '②Turn on',
        p41: 'notification to show message details',
        p42: 'and',
        p43: 'message notification',
        p44: 'switch',
        p45: '*When logging in to the computer version of WeChat, please make sure that the mute function in WeChat is',
        p46: 'turned off',
        p47: ': first, click on the',
        p48: 'banner notification',
        p49: 'on the home page of WeChat on your cell phone, then click on',
        p50: 'mute',
        p51: ', and then turn the button into gray.',
        p52: '5. It is strongly recommended that you set the Aswear Global APP as a protected background application on your cell phone and restart your phone. After setting, the stability of message push can be improved. For the setting method, please refer to the APP protected settings and click the jump.',
        p53: '6. Please restart your watch and cell phone to try.',
        p54: '7. If the problem persists, upgrade the watch and Aswear Global APP to the latest version and re-pair and connect.',
        p55: '* Aswear Global APP update: Aswear Global APP > My > About APP >APP version update.',
        p56: 'WATCH: Aswear Global APP> My Device> Firmware Update.'
    },
    iosMessageSet: {
        title: 'IOS phone messages not being pushed to watch?',
        p0: 'Message Push Principle:',
        p1: 'After the watch is connected to your iOS phone, the system gets notifications from your phone\'s notification bar and pushes them to your watch.',
        p2: '3.If you find that your watch is not receiving messages from the corresponding',
        p3: 'application',
        p4: ', take',
        p5: 'WeChat',
        p6: 'as an example, please try the following operation:',
        p7: 'Ensure that the notification settings of the cell phone system application are normal: in ',
        p8: '“Mobile Settings > Notification > WeChat >',
        p9: 'Open',
        p10: 'Allow Notification',
        p11: 'Switch',
        p12: '> Check Lock Screen, Notification Center, Banner"; Display Preview',
        p13: 'select ',
        p14: 'Always and Banner Style',
        p15: 'select ',
        p16: 'Continuous',
        p17: '.',
        p18: '① Go to Settings',
        p19: 'Notifications',
        p20: '② Find',
        p21: 'Aswear Global',
        p22: '.',
        p23: '③ Turn on the',
        p24: 'Allow Notifications',
        p25: 'switch ④ Check',
        p26: 'Lock Screen, Notification Center, and Banner',
        p27: '.',
        p28: '⑤',
        p29: 'Display Preview',
        p30: 'Select',
        p31: 'Always',
        p32: '⑥',
        p33: 'Banner Style',
        p34: 'Select ',
        p35: 'Continuous',
        p36: '.',
        p37: '2. Ensure that Shared Notifications with Watch is set up correctly:in',
        p38: 'Phone Settings > Bluetooth > tap Paired Devices >',
        p39: 'Turn on',
        p40: 'Shared System Notifications',
        p41: '.',
        p42: '① Go to Settings Bluetooth ② Tap Paired Settings ③ Turn on ',
        p43: 'Shared Notifications',
        p44: '.',
        p45: '2. If Aswear Global messages are not pushed, please open the app, select',
        p46: 'My > My Device > Device Info > Message Alerts',
        p47: ', and turn on the corresponding',
        p48: 'message type notification switch',
        p49: '.',
        p50: '① Go to ',
        p51: 'My ',
        p52: '② Select',
        p53: 'the paired device',
        p54: '③ Go to',
        p55: 'Message Alert',
        p56: '④ Turn on the corresponding message type',
        p57: 'notification switch',
        p58: '.',
        p59: '4. Please restart your watch and cell phone to try.',
        p60: '5. If the problem still exists, upgrade the watch and',
        p61: 'Aswear Global',
        p62: 'APP to the latest version and re-pair and connect.',
        p63: '*Aswear Global update:',
        p64: 'Search for Aswear Global APP in the App Store and follow the interface guidelines to download the update.',
        p65: '*Watch update path: ',
        p66: 'Aswear Global APP> Devices > Firmware Version',
        p67: '*Does the phone system pop up to ',
        p68: 'Allow TAXXX-XXXX to receive yours iPhone notifications when connecting for pairing? Click on ',
        p69: 'Allowed',
        p70: '.',
        p71: 'If the above methods still do not solve your problem or you encounter difficulties in the operation, please contact the store customer service, we will be happy to serve you, wish you a happy life!',
        p72: '1. Ensure that the notification settings for sharing with the watch are normal: Go to Phone Settings>Bluetooth>Paired Devices>Turn on Shared System Notifications.',
        p73: '',
        p74: '',
        p75: '',
        p76: '',
        p77: '① Enter Bluetooth settings ② Click on paired settings ③ Open shared notifications',
        p78: '',
        p79: 'Is the watch unable to answer mobile phone calls? (Applicable to TA700S/G watch models)',
        p80: 'Firstly, ensure that the watch is properly connected to the phone and try the following steps:',
        p81: '① Phone settings>Bluetooth, find the connected device, click on the device.',
        p82: '',
        p83: '',
        p84: '② After reloading is complete, display the connected status, and then click the exclamation mark on the right to enter the details page, ensuring that the device type is other.',
        p85: '',
        p86: '',
        p87: '',
        p88: '',
        p89: '',
        p90: '',
        p91: '',
        p92: ''
    },
    problemType: {
        title: 'Select Device Type',
        model: 'Model'
    },
    problemList: {
        title: 'Q&A',
        model: 'Model',
        all: 'Everyone is asking',
        zhibeizhen: 'Is the detection of the compass inaccurate?',
        haiba: 'Is the altitude inaccurate?',
        android: 'Android phone messages cannot be pushed to the watch?',
        ios: 'IOS phone messages cannot be pushed to the watch?',
        keepAlive: 'How to maintain the connection between your phone and watch?',
        prompt: 'Is there a permission prompt for "restricted settings" when turning on the phone?',
        instructions: 'Instructions',
        sleep: 'No sleep data for normal wear?',
        map: 'Map Download',
        ecg: 'ECG not measurable/inaccurate results?'
    },
    privacyAgreement: {
        title: 'Privacy Agreement',
        p0: 'This agreement applies to Aswear Global APP ',
        p1: 'Aswear Global is a series of products and services operated by Astrolink team. to provide you with outdoor sports and intelligent health monitoring products and services, the products are mainly smartwatches, and the services mainly include relevant apps under the Android, IOS.',
        p2: 'By using Astrolink products and services, you acknowledge that you have read, acknowledged and accepted all of the terms and conditions described in this Privacy Statement, including any changes we may make from time to time. We are committed to protecting the privacy, confidentiality and security of your personal information by law, including the data protection laws of your location. We also commit all our employees and agents to fulfill these obligations.',
        p3: '',
        p4: 'I. How we collect and use your personal information',
        p5: 'Personal information refers to all kinds of information recorded electronically or by other means that can identify a specific natural person or reflect the activities of a specific natural person, either alone or in combination with other information.',
        p6: 'Personal sensitive information is defined as including identity card numbers, personal biometric information, bank account numbers, property information, whereabouts, and transaction information.',
        p7: 'We will only collect and use your personal information for the following purposes as described in this statement.',
        p8: '1. Account Login',
        p9: 'We use email as our account system. When you log in with your email, you will receive a verification code for account binding.',
        p9p0: 'We use',
        p9p1: 'email',
        p9p2: 'as our account system. When you use',
        p9p3: 'email',
        p9p4: 'to log in, we will obtain your verification code for account binding. ',
        p9p5: '',
        p9p6: '',
        p9p7: '',
        p9p8: '',
        p9p9: '',
        p9p10: '',
        p10: 'Why we manage your exercise and health data, we need to use your account data, including your gender, weight, height, birthdate, etc. The use of gender, weight, height, birthdate is to provide you with better health advice.',
        p10p0: 'To manage your exercise and health data, we need to use your account information, including your',
        p10p1: 'gender, weight, height, date of birth, etc. The use of gender, weight, height, and date of birth',
        p10p2: 'is to provide you with better health recommendations.',
        p11: 'After you create or modify account data, it will be automatically saved locally on your phone and synchronized to the backend server.',
        p12: 'If devices and applications do not have a login account function, we will not record such data. For some products, we will not be able to provide you with online services if you do not have a login. Failure to provide information such as gender and weight after logging in may affect the accuracy of the advice we provide.',
        p12p0: 'If the device and application do not have an account login function, we will not record such data. For some products, without logging into an account, we will be unable to provide you with online services. After logging in, if you do not provide',
        p12p1: 'gender, weight, and other',
        p12p2: 'information, it may affect the accuracy of the recommendations we provide.',
        p13: 'f you want to cancel your account, you can log in to the app, go to the “My” page, click on the “Settings” column, go to the “Other Settings” page, and select the “Account & Security” column. Account and Security", click ‘Cancel Account’, we will permanently delete the account and related information after the account is canceled.',
        p105: 'When logging in, the unique device identification code (IMEI/androidID/IDFA/OPENUDID/GUID/OAID, SIM card IMSI information, etc.) of the device needs to be obtained for device management and identity verification, ensuring the security of user login and preventing password leakage and remote login by other devices.',
        p105p0: 'When logging into your account, we need to obtain the device\'s',
        p105p1: 'unique device identifiers (IMEI/android ID/IDFA/OPENUDID/GUID/OAID, SIM card IMSI information, etc.)',
        p105p2: 'for device management and identity verification to ensure login security and prevent password leakage leading to unauthorized access from other devices.',
        p14: '2. Device management',
        p15: 'In order to manage the Astrolink Watch, we need to collect your device information and network information. Device information includes the watch device identifier (MAC, SN, etc.), device type, and device configuration parameters. The purpose of collecting such information is to establish a Bluetooth connection, manage device configuration information, complete software upgrades, and display data sources. Network information includes IP address, network type, and network connection status, etc. This data will be used to enhance the network connection experience of our products.',
        p15p0: 'To manage the Astrolink watch, we need to collect your',
        p15p1: 'device information and network information',
        p15p2: '. Device information includes',
        p15p3: 'device identifiers (MAC, SN, etc.), device type, and device configuration parameters',
        p15p4: '. The purpose of collecting this information is to establish Bluetooth connections, manage device configuration, complete software upgrades, and display data sources. Network information includes',
        p15p5: 'IP address, network type, and network connection status',
        p15p6: ', which will be used to improve the network connection experience of our product.',
        p16: 'Connecting the device requires access to the phone\'s Bluetooth permissions, but we do not store the information. When our wearable devices are managed through the app, personal information and device configuration information is passed to the wearable app application through an exclusive secure channel.',
        p16p0: 'Connecting to the device requires access to your phone\'s',
        p16p1: 'Bluetooth permissions',
        p16p2: ', but we will not store related information. When our wearable device is managed through the app,',
        p16p3: 'personal information and device configuration information',
        p16p4: 'will be transmitted to the wearable app via a dedicated secure channel.',
        p17: 'If you do not provide such information, you will not be able to use our wearables and related back-end services, or some of their functionality will be limited.',
        p18: '3. Personal Health Information Management',
        p19: 'In the devices and services with ECG collection function, in order to record and manage your health data, we need to collect your exercise setting data (including exercise status, total number of heart beats, heart rate zones, etc.), and the heart rate data is categorized into exercise heart rate, daily heart rate, and the online report generated by the analysis of the heart rate data, and the heart rate data belongs to the sensitive information of the individual, and the purpose of collecting this kind of information is to carry out the measurement, recording, and display of health-related data, as well as to increase the accuracy of the analysis of heart rate data. The purpose of collecting this kind of information is to measure, record, display and increase the accuracy of ECG data analysis and to improve the service quality of our products.This function is for reference only and does not serve as a medical diagnostic basis. If you experience any discomfort, please consult a medical institution immediately.',
        p19p0: 'In devices and services with ECG monitoring capabilities, to record and manage your health data, we need to collect your exercise settings data (including',
        p19p1: 'exercise status, total heartbeats, heart rate zones, etc.',
        p19p2: '). Heart rate data is categorized into exercise heart rate, daily heart rate, and online reports generated through heart rate data analysis.',
        p19p3: 'Heart rate data',
        p19p4: 'is considered sensitive personal information. The purpose of collecting this information is to measure, record, and display health-related data, improve the accuracy of ECG data analysis, and enhance the service quality of our products. This function is for reference only and should not be used as a basis for medical diagnosis. Please consult a medical professional if you feel unwell.',
        p20: 'If you do not provide such information, it will result in severe limitations on the functionality of our app application and we will not be able to provide you with normal service.',
        p21: '4. Exercise Data Recording',
        p22: 'In order to record and manage your exercise data in devices and services with exercise recording and statistics functions, we need to collect your device location, exercise track, exercise type, exercise duration, running posture, steps, distance, altitude, and exercise heart rate, etc. Exercise types include walking, running, cycling, hiking, swimming, marathon, etc. Among them, location and track are personal sensitive information, so as to provide you with exercise display functions in the APP. Among them, location and trajectory are personal sensitive information, and the purpose of collecting such information is to record and count your daily exercise data so as to provide you with the function of displaying exercise trajectory in the APP.',
        p22p0: 'In devices and services with exercise recording and statistical functions, to record and manage your exercise data, we need to collect your',
        p22p1: 'device location, exercise route',
        p22p2: ', exercise type, duration, running posture, step count, distance, altitude, and exercise heart rate, etc. Exercise types include walking, running, cycling, hiking, swimming, marathon, etc. Among these,',
        p22p3: 'location and route',
        p22p4: 'are considered sensitive personal information. The purpose of collecting this information is to record and analyze your daily exercise data, so as to provide you with exercise route display functionality in the APP.',
        p23: 'We will count and display your relevant exercise data in the app application, and if the data is used for other purposes, this will also be done after anonymization.',
        p24: 'If you do not provide such information, statistics, analysis and presentation of the campaign cannot be provided.',
        p25: '7. Exceptions to obtaining your authorized consent',
        p26: 'In the following cases, we does not need to obtain your authorized consent for the collection and use of personal information:',
        p27: '（1）Related to national security and defense security;',
        p28: '（2）Related to public safety, public health, and vital public interests;',
        p29: '（3）Related to the investigation, prosecution, adjudication and enforcement of sentences for crimes;',
        p30: '（4）For the purpose of safeguarding the life, property, and other important legal rights and interests of the subject of personal information or other individuals, but it is difficult to obtain the consent of the individual;',
        p31: '（5）The personal information collected is disclosed to the public by the subject of the personal information himself/herself;',
        p32: '（6）Where your personal information is collected from legitimate publicly disclosed information, such as legitimate news reports, government information disclosure and other channels;',
        p33: '（7）Necessary to enter into a contract at your request;',
        p34: '（8）Necessary for maintaining the safe and stable operation of the products and/or services provided, e.g., detecting and disposing of malfunctions in the products and/or services;',
        p35: '（9）Necessary for legitimate journalism;',
        p36: '（10）When an academic research organization carries out statistical or academic research necessary in the public interest and provides the results of academic research or descriptions to the public, it de-identifies the personal information contained in the results;',
        p37: '（11）Other cases stipulated by laws and regulations.',
        p106: '6. Extended functionality based on microphone authorization',
        p107: 'You can choose to enable the microphone permission of the system and use voice technology to achieve voice interaction functions such as smart dials and voice assistants. We will collect the voice information you input during the use of intelligent voice technology for machine recognition, online interaction, and to meet your needs. You can turn off this feature in the system permissions. Once turned off, you may not be able to achieve online voice interaction, but it will not affect your enjoyment of other basic functions.',
        p38: 'II. How we entrust the processing, sharing, transferring, public disclosure of your personal information',
        p39: '1. Mandate',
        p40: 'In special cases, we may entrust other companies to process your personal information on our behalf, and we will sign a strict confidentiality agreement or terms of handling of personal information with the entrusted party, requiring them to handle the personal information in accordance with this statement as well as to take relevant confidentiality and security measures.',
        p41: '2. Share',
        p42: 'Sharing is the process by which we provide personal information to other controllers of personal information where each has independent control over the personal information. We do not share your personal information except in the following circumstances:',
        p43: '（1）Sharing with Explicit Consent: With your explicit consent, we may share information within the scope of your authorization with a third party designated by you;',
        p44: '（2）Sharing under legal circumstances: We may share your personal information in accordance with the provisions of laws and regulations, the need to resolve litigation disputes, or at the request of administrative or judicial authorities in accordance with the law;',
        p45: '3. Transfer',
        p46: 'Transfer, is the process of transferring control of personal information from us to another controller of personal information. We will not transfer your personal information to any company, organization, or individual, except in the following circumstances:',
        p47: '（1）Transfer with Explicit Consent: We may transfer your personal information to other parties with your explicit consent;',
        p48: '（2）In the event of a merger, acquisition, or bankruptcy and liquidation involving the transfer of personal information, we will require the new company or organization holding your personal information to continue to be bound by this statement, or we will require the company or organization to re-solicit authorized consent from you.',
        p49: '4. Public disclosure',
        p50: 'We will only publicly disclose your personal information in the following circumstances:',
        p51: '（1）After obtaining your express consent;',
        p52: '（2）Public Disclosure Based on Law or Reasonable Basis: We may publicly disclose information about you when required to do so by law, legal process, litigation, or public and governmental authorities;',
        p53: '5. Exceptions to obtaining prior authorized consent to share, transfer, or publicly disclose personal information',
        p54: 'In the following cases, sharing, transferring, or publicly disclosing your personal information does not require your prior authorized consent:',
        p55: '（1）Related to national security and defense security;',
        p56: '（2）Related to public safety, public health, and vital public interests;',
        p57: '（3）Related to the investigation, prosecution, adjudication and enforcement of sentences for crimes;',
        p58: '（4）For the purpose of safeguarding the life, property, and other important legal rights and interests of the subject of personal information or other individuals, but it is difficult to obtain the consent of the individual;',
        p59: '（5）Personal information that you disclose to the public on your own;',
        p60: '（6）Where your personal information is collected from legitimate publicly disclosed information, such as legitimate news reports, government information disclosure and other channels;',
        p61: 'III. Your data subject rights',
        p62: 'You can access, correct, and delete your personal information during your use of our products/services, while safeguarding your right to withdraw your consent to the use of your personal information, you can:',
        p63: '1. Get your personal information from us;',
        p64: '2. Ask us to delete your personal information;',
        p65: '3. Ask us to update your personal information;',
        p66: '4. Withdrawal gives us the right to use your personal information.',
        p67: 'IV. Location and duration of data storage',
        p68: '1. Storage location',
        p69: 'The personal information we collect and generate under the Service will be stored in the People\'s Republic of Frankfurt .',
        p70: '2. Storage period',
        p71: 'We retain your personal information only for as long as necessary to achieve the purpose, and delete or anonymize your personal information after the aforementioned retention period.',
        p72: 'For the safety of your data, your data will be tied to your account, and your health data such as ECG, exercise, etc. will be kept in our backend server until you delete the data yourself, or when you delete your app account, your data will be deleted securely at the same time.',
        p73: 'In addition, in the event of discontinuation of our products or services, we will notify you by push notification, announcement, etc. and delete or anonymize your personal information within a reasonable period of time.',
        p74: 'V. Information collected by third parties',
        p75: 'The services we provide may include third-party tracking tools belonging to our service providers. This third party may use cookies, APIs (Application Programming Interfaces), and SDKs (Software Development Kits) in connection with the Services we offer, which collect and analyze user information on our behalf. Third parties may access information such as your device identifier, MAC (Media Access Control) address, IMEI (International Mobile Equipment Identity), region (specific location in a given language), geolocation information, and IP address for the purpose of providing the Services under their respective privacy policies. Our Privacy Policy does not cover the use of third party tracking tools. We do not have access to or control over these third parties.',
        p76: 'VI. Getting the user\'s software installation list',
        p77: 'APP will get the list of app stores installed in the phone. This function is only for displaying and jumping to each app store to facilitate users to evaluate and communicate with the APP. We do not have permission to access or control these app stores and will not and do not have permission to submit your personal information to third party app stores.',
        p78: 'Integration SDK service and permission to use instructions',
        p79: '（1）Umeng plus SDK',
        p80: 'Our product integrates with Umeng plus SDK, which is required to allow the program to collect your device Mac address, unique device identifiers (IMEI/android ID/IDFA/OPENUDID/GUID, SIM card IMSI information) in order to provide statistical analysis services, and calibrate the report data accuracy by geolocation to provide basic anti-cheat services.',
        p81: '（2）GeiTui SDK',
        p82: 'Our products are integrated with GeiTui SDK, which needs to allow the program phone your device platform, device manufacturer, device brand, device model and system version, OAID, AndroidID, WIFI connection information, carrier information, in order to ensure the accurate delivery of the message push and accurate identification of the message device.',
        p83: '（3）Bugly SDK',
        p84: 'Our product integrates Bugly SDK, Android phone needs to collect your phone model, phone brand, Android system version, Android system api level, vendor system version, cpu architecture type, whether the device is rooted or not, the size of the disk space occupied, the size of the sdcard space occupied, the size of the memory space occupied, the type of network, the name of the process currently running and the PID; IOS phone needs to collect your device model, operating system version, operating system internal version number, wifi status, cpu attributes, memory space remaining, disk space/disk space remaining, the name of the process currently running and the PID. process name and PID currently running; IOS phones need to collect your device model, OS version, OS internal version number, wifi status, cpu attributes, memory space remaining, disk space/disk space remaining, phone status at runtime (memory occupied by processes, virtual memory, etc.), idfv, whether jailbroken or not, and region code. If the APP runs abnormally in the background, SDK may collect the above personal information of end users in the background for troubleshooting and dealing with crash problems.',
        p85: 'Appendix:',
        p86: 'SDK integration and list of required permissions',
        p87: 'Umeng plus',
        p88: 'Required for statistics on user activity and other operational data',
        p89: 'ACCESS_NETWORK_STATE;' +
            'ACCESS_WIFI_STATE;' +
            'READ_PHONE_STATE',
        p90: 'GeiTui',
        p91: 'For push messages',
        p92: 'INTERNET;' +
            'ACCESS_NETWORK_STATE;' +
            'ACCESS_WIFI_STATE;' +
            'SCHEDULE_EXACT_ALARM;' +
            'BADGE_ICON;' +
            'READ_EXTERNAL_STORAGE;' +
            'WRITE_EXTERNAL_STORAGE;' +
            'READ_PHONE_STATE;' +
            'IDFA',
        p93: 'Bugly',
        p94: 'Used to collect crash information',
        p95: 'INTERNET;' +
            'ACCESS_NETWORK_STAT',
        p96: 'VII. How this statement can be updated',
        p97: 'We will reserve the right to update this Statement in due course. When the Statement is changed, we will show you the changed Statement in the form of push notification through the App or WeChat public number. Only after obtaining your consent, we will collect, use and store your personal information in accordance with the updated statement.',
        p98: 'This statement is effective as of the date of its update.',
        p99: 'Last updated: June 3, 2025',
        p100: 'Astrolink team',
        p101: '5、IP address',
        p102: 'In order to assign servers in close proximity to each other and to improve overall user usage and access speed, we will collect your IP address.',
        p103: '（4）PushReceiver SDK',
        p104: 'PushReceiver SDK has a self-start function, in order to ensure that the application is closed or background running state can normally receive the cellar end of the push information, there will be a certain frequency through the system to send a broadcast to wake up the application of self-start or associated with the start behavior, is necessary for the realization of the function and service. This application must use (self-start) ability, its purpose is to ensure the stability of the push channel, in order to push messages to the Android device in a normal and timely manner. When the system sends a broadcast, it will wake up the PushReceiver SDK self-starting behavior. Since the PushReceiver SDK is integrated into the application, when the PushReceiver SDK starts up, the application starts up as well. This behavior is necessary to implement the PushReceiver function and service.',
        p108: '（5）Baidu Maps SDK',
        p109: 'Our product integrates Baidu Maps SDK, which requires the program to obtain your network access permission, location permission, etc. Network access permission is used to access location services in order to provide you with location functionality, while WiFi information access is used for network location; The weather function, city selection function, and sports function of this application require the use of location positioning to provide relevant services.',
        p110: 'Baidu Maps',
        p111: 'Used for positioning function',
        p112: 'ACCESS_FINE_LOCATION、ACCESS_COARSE_LOCATION、INTERNET'
    },
    samSet: {
        title: 'The solution of "Restricted Settings" when opening permissions on cell phone',
        p0: 'This is often seen on Motorola, Samsung and other cell phones and can be handled in the following two ways.',
        p1: 'Method I:',
        p2: '1. Long press the Aswear Global APP\'s icon on your phone desktop > App Info > 3-dot menu in the upper right corner > Allow Restricted Settings.',
        p3: '2. Go to Phone Settings > Notifications > Device and App Notifications > select Aswear Global APP > Grant notification access.',
        p4: 'Method II:',
        p5: 'Here\'s how Samsung phones handle it:',
        p6: '1. Go to Phone Settings > Applications > More Options (3 dots marked in the figure below)',
        p7: '2. Selection ',
        p8: 'special access',
        p9: '3. Selection ',
        p10: 'Notification access',
        p11: '4. Turn on',
        p12: 'Aswear Global ',
        p13: ''
    },
    water: {
        title: 'WATER REMINDER',
        time0: 'day',
        time1: 'week',
        time2: 'month',
        time3: 'year',
        today: 'Water intake',
        surplus: 'Surplus ',
        math0: 'Max',
        math1: 'Min',
        math2: 'Completion rate',
        math3: 'Daily highest',
        math4: 'Daily minimum',
        chartUnit: '  Daily',
        descTitle: 'Suggestions for drinking water',
        desc: 'Water is one of the main components of the human body, and ensuring sufficient water intake is essential for maintaining good health. Everyone\'s specific needs may vary depending on age, gender, weight, activity level, and environment. Normally, the recommended daily water intake for adult males is 2-3 liters, while for adult females it is 1.5-2.5 liters, which may vary depending on individual circumstances. Drinking water regularly every day and using a water cup to track the amount of water consumed is beneficial for developing healthy drinking habits.',
        maxCountDesc: 'The drinking volume has reached the upper limit~'
    },
    weight: {
        title: 'Weight Record',
        time0: 'week',
        time1: 'month',
        time2: 'year',
        level0: 'Underweight',
        level1: 'Normal',
        level2: 'Overweight',
        level3: 'Obese',
        desc0: 'BMI (Body Mass Index) is a standard used internationally to measure the degree of human body fat and health. The calculation formula is: BMI = weight ÷ height². (Weight unit: kilograms; Height unit: meters). However, it is not a perfect tool, especially in evaluating individuals with significant differences. Therefore, it is recommended to use BMI in conjunction with other health indicators to obtain a more comprehensive health assessment. ',
        desc1: 'BMI range explanation: ',
        desc2: '<18.5 Underweight',
        desc3: '18.5~23.9 Normal',
        desc4: '24.0~29.9 Overweight',
        desc5: '>30 Obese',
        change: 'Change',
        popTitle: 'Record today\'s weight',
        height: 'Height: ',
        heightPop: 'Height'
    },
    planEdit: {
        title: 'Plan Editing',
        save: 'Save',
        planName: 'Plan name',
        planNameDesc: 'Please enter',
        action: 'Action',
        actionAdd: 'Add action',
        capacity: 'Capacity',
        group: 'Group',
        weight: 'Weight',
        frequency: 'Times',
        distance: 'Distance',
        duration: 'Time',
        duration1: 'Time',
        common: 'Common',
        inputPlaceholder: 'Please enter valid required fields',
        actionListPlaceholder: 'Add at least one action',
        success: 'Operation successful！',
        maxTip: 'Add up to 20 groups'
    },
    actionLibrary: {
        title: 'Action Library',
        searchDesc: 'Please enter the action name to search',
        action1: 'Whole Body',
        action2: 'Shoulder',
        action3: 'Arms',
        action4: 'Chest',
        action5: 'Back',
        action6: 'Core',
        action7: 'Hips and Legs',
        action8: 'Custom',
        confirm: 'Confirm',
        customize: 'Custom action',
        customizeDesc: 'Create your own actions',
        instrument1: 'Bare-handed',
        instrument2: 'Dumbbell Bench',
        instrument3: 'Flat Bench',
        instrument4: 'Power Rack',
        instrument5: 'Pull-up Machine',
        instrument6: 'Swiss Ball',
        instrument7: 'Bungee Cord',
        instrument8: 'Ab Bench',
        instrument9: 'Barbell bench',
        instrument10: 'Hack Squat Machine',
        instrument11: 'Leg Press Machine',
        instrument12: 'Rope',
        instrument13: 'Rope machine',
        instrument14: 'Pastor\'s stool',
        instrument15: 'Hex Bar',
        instrument16: 'Leg Curl Machine',
        instrument17: 'Barbell',
        instrument18: 'Dumbbell',
        instrument19: 'Seated Calf Raise',
        instrument20: 'Lat PullDown Machine',
        instrument21: 'T Barbell',
        instrument22: 'Smith Machine',
        instrument23: 'Crunch Machine',
        instrument24: 'Others',
        instrument25: 'Rope',
        muscles1: 'Trapezius',
        muscles2: 'Pectoralis Major',
        muscles3: 'Biceps',
        muscles4: 'Triceps',
        muscles5: 'Forearms',
        muscles6: 'Latissimus Dorsi',
        muscles7: 'Erector Spinae',
        muscles8: 'Gluteus',
        muscles9: 'Hamstring muscles',
        muscles10: 'Abs',
        muscles11: 'Quadriceps Femoris',
        muscles12: 'Adductor',
        muscles13: 'Abductor',
        muscles14: 'Calf Muscles',
        muscles15: 'Deltoid',
        detailBtn: 'Introduction',
        maxTip: 'Add up to 10 actions'
    },
    actionDesc: {
        title: 'Action details',
        part: 'Training area',
        point: 'Action points',
        delete: 'Delete'
    },
    actionEdit: {
        title: 'Action editing',
        actionName: 'Action name',
        actionNamePlaceholder: 'Please enter the action name',
        actionPart: 'Training area',
        actionPartPlaceholder: 'Please select the training area',
        actionInstrument: 'Training equipment',
        actionInstrumentPlaceholder: 'Please select training equipment',
        recordType: 'Recorded data',
        recordTypePlaceholder: 'Please select to record data',
        actionBanner: 'Action Cover',
        actionBannerPlaceholder: 'Please upload the action cover',
        actionMuscles: 'Training muscle groups',
        actionMusclesPlaceholder: 'Please select the training muscle group',
        actionPoint: 'Action points',
        actionPointPlaceholder: 'Please enter the action points',
        save: 'Save',
        selectPlaceholder: 'Please select',
        recordType1: 'Weight and frequency',
        recordType2: 'Time only',
        recordType3: 'Only times',
        recordType4: 'Only distance',
        pointPlaceholder: 'Can describe the correct posture, technical points, and precautions for this action.',
        delete: 'Delete Action',
        deleteTitle: 'Delete prompt',
        deleteDesc: 'Are you sure you want to delete this action?',
        confirm: 'Confirm',
        cancel: 'Cancel'
    },
    setPlanDate: {
        title: 'Set training date',
        repeatWeek: 'Repeat',
        startDate: 'Start Date',
        endDate: 'End Date',
        week0: 'Mon',
        week1: 'Tue',
        week2: 'Wed',
        week3: 'Thu',
        week4: 'Fri',
        week5: 'Sat',
        week6: 'Sun',
        confirm: 'Confirm',
        cancel: 'Cancel',
        repeatTips: 'Please select at least one repeating cycle',
        repeatText: '',
        repeatText0: 'Mon',
        repeatText1: 'Tue',
        repeatText2: 'Wed',
        repeatText3: 'Thu',
        repeatText4: 'Fri',
        repeatText5: 'Sat',
        repeatText6: 'Sun',
        repeatText7: 'Every day',
        repeatTextSplit: ',',
        import: 'Import into Training Calendar',
        isRemind: 'Set reminder',
        remindTime: 'Reminder Time',
        planErrorMsg: 'The plan does not exist, please exit and try again',
        maxTip: 'Import up to 10 training plans simultaneously'
    },
    planLibrary: {
        title: 'Plan Library',
        history: 'Historical plan',
        create: '+Create',
        progress: 'In progress',
        group: 'Group',
        capacity: 'Capacity',
        action: 'Action',
        groupCount: 'Group'
    },
    planDesc: {
        title: 'Plan details',
        start: 'Started training',
        edit: 'Edit',
        delete: 'Delete',
        out: 'Exit',
        outPlan: 'Exit plan',
        outPlanDesc: 'After exiting the training program, the previous exercise records will not be cleared. Are you sure you want to exit?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        deleteTitle: 'Delete reminder',
        deleteDesc: 'The current plan is in progress. Do you want to stop the current plan and delete it?',
        success: 'Delete successfully!'
    },
    trainCalendar: {
        title: 'Training calendar',
        seeDetail: 'View details'
    },
    startTrain: {
        title: 'Started training',
        finish: 'Complete',
        action: 'Action',
        group: 'Group',
        capacity: 'Capacity',
        rest: 'Rest',
        duration: 'Time',
        startTiming: 'Start timing',
        feel: 'Training experience',
        confirm: 'Confirm',
        easy: 'Easy',
        normal: 'Normal',
        hard: 'Hard',
        feelInput: 'Write down your training experience for today and the things you think are worth noting'
    },
    sportTrainDesc: {
        title: 'Sports details',
        rest: 'Rest',
        cal: 'Calorie',
        hr: 'HR',
        hrUnit: 'bpm',
        max: 'Max',
        min: 'Min',
        avg: 'Avg',
        hrRange0: 'Extreme range',
        hrRange1: 'Anaerobic interval',
        hrRange2: 'Endurance range',
        hrRange3: 'Aerobic interval',
        hrRange4: 'Warm up interval',
        trainEffect: 'Training effect',
        trainFeel: 'Training experience',
        trainParts: 'Training area',
        effect0: 'Resilience',
        effect1: 'Explosiveness',
        effect2: 'Endurance',
        effect3: 'Power',
        effect4: 'Reach',
        dataFrom: 'Data comes from '
    },
    activeTarget: {
        title: 'GOAL SETTING',
        step: 'Target Steps',
        cal: 'Target Calories',
        strength: 'Target Active Time',
        stepUnit: 'step/day',
        calUnit: 'kcal/day',
        strengthUnit: 'min/day'
    },
    userCheckup: {
        title: 'Examination report',
        all: 'All',
        normal: 'Normal',
        error: 'Abnormal',
        conclusion0: 'No obvious abnormalities were observed',
        conclusion1: ' anomalies',
        numText0: 'There are a total of 6 items, and ',
        numText1: ' items have been successfully detected',
    },
    checkupDesc: {
        title: "Report Details",
        device: 'Device',
        checkupTime: 'Time',
        conclusion0: 'Completed ',
        conclusion1: ' tests',
        term: ' items',
        normal: 'Normal',
        error: 'Abnormal',
        termTitle: 'METRIC DETAILS',
        error1: 'Abnormal',
        hr: 'AVG.HEART RATE',
        hrRefer: 'Ref: 60~100 bpm',
        hrUnit: 'bpm',
        hrDesc: 'Normal heart rate ranges vary by age and physiological state. Typically, adults have a resting heart rate of 60~100 bpm.',
        bos: 'SPO₂',
        bosRefer: 'Ref: 95%~100%',
        bosLevel0: 'Normal',
        bosLevel1: 'Mild hypoxia',
        bosLevel2: 'Moderate hypoxia',
        bosDesc: 'Normal blood oxygen saturation for healthy adults ranges 95%~100%. Values may vary due to altitude, activity level, and health conditions.',
        pressure: 'STRESS',
        pressureLevel0: 'Low',
        pressureLevel1: 'Normal',
        pressureLevel2: 'Medium',
        pressureLevel3: 'High',
        pressureDesc: 'Managing high stress promotes health. Ranges: 1-29 Low; 30-59 Normal; 60-79 Medium; 80-99 High',
        temperature: 'TEMP',
        temperatureRefer: 'Ref: 36～37℃',
        temperatureError: '＞38',
        skin: 'Skin temp:',
        temperatureDesc: 'Normal body temp varies by measurement site. Axillary temp normally ranges 36～37℃. Skin temp fluctuates with environment and physiology, with wrist typically 32.0~34.0℃ at room temp.',
        rate: 'RR',
        rateUnit: '/min',
        rateRefer: 'Ref: 12~20 /min',
        rateDesc: 'Normal respiratory rate varies by age and state. Adult resting rate is typically 12~20 breaths/min.',
        ecg: 'ECG',
        ecgScore: 'pts',
        ecgLevel0: 'Excellent',
        ecgLevel1: 'Good',
        ecgLevel2: 'Fair',
        ecgLevel3: 'Poor',
        ecgLevel4: 'Very Poor',
        ecgMore: 'Details',
        tips: 'NOTE',
        tipsText: 'This report uses smartwatch sensor data and algorithms. Device limitations may affect accuracy. For personal reference only - not medical advice. Consult a doctor for abnormal results.'
    },
    deepSeek: {
        analysis: 'Analyzing, please wait',
        placeholder: 'Ask me',
        ing: 'The current task is being answered',
        relief: 'AI-generated content. Verify carefully.'
    },
    sportIndex: {
        title: 'Sports Metrics',
        pace: 'Pace',
        paceDesc: 'The time required to complete 1 kilometer (unit: min/km).',
        avgPace: 'Average Pace',
        avgPaceDesc: 'The average pace across all kilometers during a single workout. You can also view segment-specific average pace in detailed data.',
        avgMovePace: 'Average Moving Pace',
        avgMovePaceDesc: 'Similar to average pace but excludes stationary time during workouts, only calculating pace during actual movement (running, walking, etc.). It is typically faster than average pace.',
        bestPace: 'Fastest 1 km Pace',
        bestPaceDesc: 'The fastest 1 km pace during the entire activity may be faster than the fastest pace in the [Split Data].',
        bestPaceDesc1:  'Using the default 1 km split as an example:',
        speed: 'Speed',
        speedDesc: 'The distance covered per unit of time (unit: km/h).',
        avgSpeed: 'Average Speed',
        avgSpeedDesc: 'Total distance ÷ total time of the workout, reflecting the overall average speed.',
        avgMoveSpeed: 'Average Moving Speed',
        avgMoveSpeedDesc: 'Similar to average speed but excludes stationary time during workouts, only calculating speed during actual movement. It is typically faster than average speed.',
        bestSpeed: 'Fastest 1 km Speed',
        bestSpeedDesc: 'The fastest 1 km speed during the entire activity may be faster than the fastest speed in the [Split Data].',
        hrRange: 'Heart Rate Zone',
        hrRangeDesc: 'To make training more efficient and safer, workouts are divided into 5 intensity zones based on maximum heart rate (determined by age and gender):',
        hrRange0: '1. Warm-up Zone (50%~60% max HR):',
        hrRange0Desc: 'Low-intensity zone typically used for warm-ups or cool-downs.',
        hrRange1: '2. Aerobic Zone (60%~70% max HR):',
        hrRange1Desc: 'Comfortable intensity with steady breathing and ability to speak easily. Ideal for building foundational aerobic capacity.',
        hrRange2: '3. Endurance Zone (70%~80% max HR):',
        hrRange2Desc: 'Moderate-high intensity with deeper breathing, difficulty speaking continuously, and gradual muscle fatigue. Improves cardiovascular function and endurance.',
        hrRange3: '4. Anaerobic Zone (80%~90% max HR):',
        hrRange3Desc: 'High intensity with labored breathing, inability to speak coherently, and noticeable muscle soreness. Suitable for speed training or performance breakthroughs (e.g., sprint drills).',
        hrRange4: '5. Maximum Effort Zone (90%~100% max HR):',
        hrRange4Desc: 'Extreme intensity near physical limits, placing heavy load on heart and muscles. Characterized by rapid heartbeat, extreme breathlessness, and quick fatigue. Used for testing limits or explosive power (e.g., sprinting), but requires professional guidance due to high risk.',
        hrRecover: 'Heart Rate Recovery',
        hrRecoverDesc: 'The heart\'s ability to return to normal rate post-exercise. Calculated as the difference between HR at workout end and 1 minute later. A larger drop indicates better recovery capacity.',
        strideF: 'Cadence',
        strideFDesc: 'Number of steps per minute during running/walking (unit: steps/min). Average runners: 160–180 steps/min; experienced runners: 180–200 steps/min. Higher cadence reduces impact forces and injury risk. Beginners can practice "short quick steps" to target 180 steps/min (optimal cadence). Avoid compromising form (e.g., knee valgus) when increasing cadence.',
        stride: 'Stride Length',
        strideDesc: 'Distance between foot strikes during running/walking (unit: m/step). Average runners: 0.7–1.2m/step; elite runners: 1.5m+/step. Longer strides improve efficiency but increase joint impact. Beginners should prioritize cadence before gradually increasing stride length to avoid excessive knee stress.',
        calories: 'Calories Burned',
        caloriesDesc: 'Energy expended during exercise (unit: kcal).',
        carbohydrate: 'Carbohydrates',
        carbohydrateDesc: 'Primary energy sources during exercise are carbs and fats, with ratios varying by intensity, duration, and metabolism. Estimates are algorithm-based with individual variances—focus on trends (e.g., long-term fat utilization) rather than absolute values.',
        sweatLoss: 'Sweat Loss',
        sweatLossDesc: 'Algorithm-estimated sweat volume based on workout intensity and environment. Does not account for individual differences (e.g., natural sweat tendencies).',
        power: 'Power',
        powerDesc: 'Algorithm-estimated sweat volume based on workout intensity and environment. Does not account for individual differences (e.g., natural sweat tendencies).',
        avgPower: 'Average Power',
        avgPowerDesc: 'Average power output during a run.',
        maxPower: 'Max Power',
        maxPowerDesc: 'Average power output during a run.',
        trainingLoad: 'Training Load',
        trainingLoadDesc: 'Cumulative effect of workout intensity over time. Higher intensity/longer duration increases load.',
        effect: 'Aerobic/Anaerobic Effect',
        effectDesc: 'Scores (0-6.0) based on time spent in aerobic/anaerobic zones. Higher aerobic scores may indicate improved VO2 max (e.g., lower HR at same pace); higher anaerobic scores may reflect strength/speed gains (e.g., more reps at same weight).',
        vo2max: 'Estimated VO2 Max',
        vo2maxDesc: 'Maximum oxygen uptake (ml/kg/min) during peak exertion, measuring cardio-respiratory endurance. Higher values indicate efficient oxygen utilization. Estimated via workout data and biometrics when intensity/duration thresholds are met.',
        verSpeed: 'Vertical Speed',
        verSpeedDesc: 'Rate of ascent/descent per unit time (unit: m/h).',
        rate: 'Breathing Rate',
        rateDesc: 'Breaths per minute (unit: breaths/min). Steady rhythms enhance movement stability and focus.',
        trips: 'Laps',
        tripsDesc: 'In swimming, one length of the pool counts as a lap (e.g., 50m pool: end-to-end = 1 lap).',
        avgSwolf: 'Average SWOLF',
        avgSwolfDesc: 'Swimming efficiency metric: SWOLF = lap time + stroke count. Lower values indicate higher efficiency. Average SWOLF calculates this over longer distances.',
        swimSpeed: 'Pace per 100m',
        swimSpeedDesc: 'Time to swim 100m (unit: min/100m).',
        frequency: 'Frequency',
        frequencyDesc: 'Complete "rope swing + jump" cycles per minute (unit: cycles/min).',
        strokeRate: 'Stroke Rate',
        strokeRateDesc: 'Swimming strokes per minute (unit: strokes/min). One stroke = full left + right arm cycle.',
        fitness: 'Fitness Level',
        fitnessDesc: 'Comprehensive assessment (0-100%) of physiological changes during training based on intensity, duration, and recovery. Use as reference alongside subjective feedback (e.g., fatigue, muscle response).',
    },
    importMp3: {
        title: 'SYNTIME5 import MP3',
        p1: 'Note: This tutorial is for Syntime5 watches. Only MP3 format is supported for music.',
        p2: 'To import music via iOS or Android phones (using WeChat App to download MP3 files as an example):',
        title1: '[Android Phone]',
        title2: '[iOS Phone]',
        p3: '1. Save MP3 files from WeChat App to local phone storage',
        p4: '1) Open WeChat, find the target music file and tap to open it;',
        p5: '2) Tap the button, a dialog will pop up. Tap "Save" to store the file locally on your phone, as shown below:',
        p6: '2. Use Aswear App to import music to the watch',
        p7: '1) Go to Device - Music Management to enter the music management page',
        p8: '2) Tap [Add Music], navigate to the file selection page, and select the downloaded MP3 file to import. The import process may take some time, please be patient;',
        p9: '1. Save MP3 files from WeChat App to local phone storage',
        p10: '1) Open WeChat, find the target music file and tap to open it;',
        p11: '2) Tap the button, a dialog will pop up. Select [Open with other apps], as shown below:',
        p12: '3) A dialog will appear. Select [Save to "Files"] to save to your phone storage, as shown below:',
        p13: '2. Use Aswear App to import music to the watch',
        p14: '1) Go to Device - Music Management to enter the music management page',
        p15: '2) Tap [Add Music], navigate to the file selection page, and select the downloaded MP3 file to import. The import process may take some time, please be patient.',
    },
    report: {
        title: 'Report',
        type: [
            'Harmful/Dangerous',
            'Pornography/Vulgar Content',
            'Abusive/Harassment',
            'Illegal Activities',
            'Privacy Related',
            'Copyright/Reputation Infringement',
            'Others'
        ],
        content: 'We want to know why you are reporting. Please describe the issue you encountered',
        submit: 'Submit',
    },
    nfc: {
        title: 'FAQ',
        title1: 'Supported Range:',
        p1: '1. Currently, only non-encrypted access cards with a frequency of 13.56MHz on the market are supported;',
        p2: '2. Bank cards with access card functionality and access cards with stored-value consumption or public transportation payment functions cannot be simulated. Even if simulated successfully, these cards will not support banking or public transportation features.',
        title2: 'How to Use the Access Card:',
        p3: 'Enter the "Access Card" function on the watch, switch to the corresponding access card page, wait for the card to activate and display "Hold near the感应区 to swipe," then place the watch face close to the access device to swipe directly.',
        title3: 'Access Card Quantity Limit:',
        p4: 'Supports adding up to 4 access cards in total.',
        title4: 'What if there is no response when swiping the card?',
        p5: 'Some door locks do not support swiping with watch access cards or inconsistent verification information from different gates may cause some gates to fail swiping (such as community access cards that can be swiped, elevators that cannot be swiped). We recommend using physical access cards. ',
        title5: 'What should I do if the simulation or card swipe fails?',
        p6: 'If you attempt to simulate multiple times or fail to swipe your card, please create a blank card to write to the property management. If you still cannot swipe the card after writing, it may be due to incompatibility between the chip and the gate. It is recommended to use the original physical access card. ',

    },
    waterSet: {
        title: 'SET',
        dailyTarget: 'Target',
        cup: 'Water cup quantity',
        reminder: 'Daily reminder',
        reminderStart: 'Start reminder time',
        reminderEnd: 'End reminder time',
        reminderFrequency: 'Reminder frequency',
        frequency0: '30 min',
        frequency1: '1 hour',
        frequency2: '2 hour',
        save: 'SAVE',
        success: 'SUCCESS'
    },
    recovery: {
        title: 'Recovery',
        trends: 'Recovery Trends',
        average: 'AVERAGE',
        avgScore: 'AVG SCORE',
        vsLastWeek: '(VS Last Week)',
        vsLastMonth: '(VS Last Month)',
        days: ' days',
        scoreGt75: '(>75%)',
        score50to75: '(50%~75%)',
        scoreLt50: '(<50%)',
        scoreGe80: '(≥80)',
        score60to79: '(60~79)',
        scoreLe60: '(＜60)',
        suggestText: 'Great recovery this week! Keep up the good work.',
        hrvAndHr: 'HRV & RESTING HR',
        heartRate: 'HEART RATE',
        avgHeartRate: 'AVG HEART RATE',
        hrv: 'HRV',
        avgHrv: 'AVG HRV',
        restingHr: 'RESTING HR',
        avgRestingHr: 'AVG RESTING HR',
        respiratoryRate: 'RESPIRATORY RATE',
        avgRespiratoryRate: 'AVG RESPIRATORY RATE'
    },
    activity: {
        title: 'Activity',
        scoreTitle: 'Activity Score',
        activityScore: 'ACTIVITY SCORE',
        moderateVigorousTime: 'MODERATE-VIGOROUS TIME',
        avgModVigTime: 'AVG MOD-VIG TIME',
        calories: 'CALORIES',
        avgCalories: 'AVG CALORIES',
        steps: 'STEPS',
        avgSteps: 'AVG STEPS',
        stepsUnit: 'steps',
        minUnit: 'min',
        vigorous: 'VIGOROUS',
        moderate: 'MODERATE',
        basalBurn: 'BASAL BURN',
        activityBurn: 'ACTIVITY BURN'
    },
    timeLine: {
        title: '24-HOUR TIMELINE',
    },
    sleepAhi: {
        title: 'RISK OF SLEEP APNEA'
    },
    vitalSigns: {
        title: 'Vital Signs',
        heartRate: 'HEART RATE',
        restingHr: 'RESTING HR',
        hrv: 'HRV',
        spo2: 'SPO2',
        respRate: 'RESP.RATE',
        unitBpm: 'bpm',
        unitMs: 'ms',
        unitPercent: '%',
        unitBrMin: 'br/min',
        within: 'Within ',
        outside: 'Outside ',
        latest: 'LATEST',
    }
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js